<template>
  <div id="main">
    <div id="manu">
      <navigation />
    </div>
    <div class="registervideoContainer">
      <video class="fullscreenVideo" id="registervideo" playsinline autoplay muted loop>
        <source src="../assets/Login.mp4">
      </video>
    </div>
    <div class="w">
      <div id="contentBox">
        <div class="zhuce">
          <div class="container">
            <h1>管理员登录</h1>
            <form @submit.prevent="handleLogin">
              <div class="form-group">
                <label for="admin_username">用户名</label>
                <input type="text" id="admin_username" v-model="loginForm.username" placeholder="请输入用户名" required />
              </div>
              <div class="form-group">
                <label for="admin_password">密码</label>
                <input type="password" id="admin_password" v-model="loginForm.password" placeholder="请输入密码" required />
              </div>
              <div class="form-group">
                <label for="adminCaptchaCode">验证码</label>
                <input 
                  type="text" 
                  id="adminCaptchaCode" 
                  v-model="captchaCode" 
                  placeholder="验证码" 
                  required 
                />
                <canvas id="adminCaptchaCanvas" width="100" height="30" @click="generateCaptcha"></canvas>
              </div>
              <div class="form-group">
                <button type="submit">登录</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { ElNotification } from 'element-plus';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const router = useRouter();
    const loginForm = ref({
      username: '',
      password: ''
    });
    const captchaCode = ref('');
    const generatedCaptcha = ref('');

    // 生成验证码
    const generateCaptcha = () => {
      const canvas = document.getElementById('adminCaptchaCanvas');
      const ctx = canvas?.getContext('2d');

      if (!canvas || !ctx) {
        console.error('Canvas or context not found');
        return;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let captcha = '';
      for (let i = 0; i < 5; i++) {
        captcha += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      generatedCaptcha.value = captcha;

      ctx.font = '24px Arial';
      ctx.fillStyle = '#000';
      ctx.textBaseline = 'middle';
      ctx.fillText(captcha, 10, canvas.height / 2);

      for (let i = 0; i < 10; i++) {
        ctx.strokeStyle = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.8)`;
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }
    };

    onMounted(() => {
      generateCaptcha();
    });

    // 处理登录
    const handleLogin = async () => {
      if (captchaCode.value.toLowerCase() !== generatedCaptcha.value.toLowerCase()) {
        ElNotification({
          title: '错误',
          message: '验证码不正确',
          type: 'error',
        });
        generateCaptcha();
        return;
      }
      try {
        console.log('发送管理员登录请求:', loginForm.value);
        const response = await axios.post('https://a.410121.xyz/api/admin/login', loginForm.value);
        console.log('后端响应:', response.data);
        if (response.data.code === 200) {
          localStorage.setItem('isAdminLoggedIn', 'true');
          localStorage.setItem('adminId', response.data.data.adminId);
          localStorage.setItem('adminUsername', response.data.data.username);
          localStorage.setItem('adminToken', response.data.data.token); // 存储 token
          ElNotification({
            title: '成功',
            message: '管理员登录成功',
            type: 'success',
          });
          console.log('即将跳转到 /generate');
          await router.push('/generate');
          console.log('跳转已触发');
        } else {
          throw new Error(response.data.message || '登录失败');
        }
      } catch (error) {
        console.error('管理员登录失败:', error);
        const message = error.response?.data?.message || error.message || '未知错误';
        ElNotification({
          title: '登录失败',
          message,
          type: 'error',
        });
        generateCaptcha();
      }
    };

    return {
      loginForm,
      captchaCode,
      generateCaptcha,
      handleLogin
    };
  }
};
</script>
  
  <style scoped>
  .w{
    width: 1700px;
    margin: 0 auto;
  }
  /* loginmp4背景 */
  #registervideo{
    transform: translateX(0%);
  }
  /* 视频login */
  .registervideoContainer{
    margin-top: -10vh;
    position: fixed;
    z-index: -1;
  }
  .registervideoContainer:before{
    position: absolute;
  }
  .active{
    font-size: 24px;
    font-weight: bold;
    color: var(--login-color);
  }
  .qiehua{
    text-align: center;
    display: flex;
    margin: 0 auto;
    width: 100px;
    line-height: 40px;
  }
  .qiehua>div{
    flex: 1;
    margin-top: 100px;
    cursor: pointer;
    font-size: 25px;
    color: var(--login-color);
  }
  .qiehua1{
    display: flex;
    line-height: 40px;
    margin-left: 60px;
    color: var(--shadow-right-bottom-color);
  }
  .qiehua1>div{
    flex: 1;
    cursor: pointer;
    color: var(--div-color);
  }
  /* 过渡效果的CSS */
  .slide-fade-enter-active, .slide-fade-leave-active {
    transition: all 0.5s ease;
    position: absolute;
    width: 100%;
  }
  
  .slide-fade-enter, .slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
    transform: translateX(30%);
    opacity: 0.1;
  }
  
  .slide-fade-leave, .slide-fade-enter-to {
    transform: translateX(0%);
    opacity: 0.3;
  }
  
  .denglu .container {
    width: 300px;
    padding: 20px;
    background: var(--denglu-color);
    border-radius: 5px;
    box-shadow: 0 2px 5px var(--denglu-box-color);
    margin: 20px auto;
  }
  .denglu button {
    width: 100%;
    background-color: var(--login-button);
    color: var(--login-color);
    padding: 10px;
    border: none;
    text-align: center;
    cursor: pointer;
  }
  .form-group {
    margin-bottom: 20px;
  }
  .container h2 {
    text-align: center;
  }
  .form-group label {
    display: block;
    margin-bottom: 5px;
  }
  .form-group input {
    width: 100%;
    padding: 10px;
    border-radius: 3px;
    border: 1px solid var(--input-color);
    box-sizing: border-box;
  }
  .form-group .button {
    display: block;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    background-color: var(--form-button-color);
    color: var(--login-color);
    border: none;
    border-radius: 3px;
    text-align: center;
  }
  #Login,
  #register,
  #login_username,
  #login_password,
  #register_username,
  #register_password,
  #register_confirm_password,
  #captchaCode,
  #loginCaptchaCode,
  #registerCaptchaCode{
    border-radius: 15px;
    box-shadow: 0 2px 5px var(--shadow-right-bottom-color);
    background-color: var(--login-fize-color);
    color: var(--login-button);
  }
  #Login:hover,
  #register:hover{
    background-color: var(--login-hover-color);
  }
  
  .zhuce .container {
    width: 300px;
    padding: 20px;
    background: var(--zhuce-contaier-color);
    border-radius: 5px;
    box-shadow: 0 2px 5px var(--zhuce-color);
    margin: 20px auto;
  }
  .zhuce .container h2{
    text-align: center;
    margin-bottom: 20px;
  }
  .zhuce input, input, input {
    width: 100%;
    padding: 10px;
    border-radius: 3px;
    border: 1px solid var(--input-color);
    box-sizing: border-box;
    margin: 10px 0;
  }
  
  .zhuce button {
    width: 100%;
    background-color: var(--login-button);
    color: var(--login-color);
    padding: 10px;
    border: none;
    text-align: center;
    cursor: pointer;
  }
  /* 验证码 */
  #loginCaptchaCode,
  #registerCaptchaCode{
    margin-top: -2px;
    width: 60%;
  }
  #loginCaptchaCanvas,
  #registerCaptchaCanvas{
    height: 25px;
    width: 80px;
  }
  @media screen and (max-width: 1600px) {
    .w {
      max-width: 1400px;
    }
    #contentBox {
      width: calc(100% - 5px);
    }
  }
  @media screen and (max-width: 1400px) {
    .w{
      max-width: 1200px;
    }
    #contentBox {
      width: calc(100% - 5px);
    }
  }
  @media screen and (max-width: 1200px) {
    .w{
      max-width: 1000px;
    }
    #contentBox {
      width: calc(100% - 5px);
    }
  }
  /* 手机尺寸 */
  @media screen and (max-width: 1000px) {
    .w{
      max-width: 100%;
    }
    #contentBox {
      width: calc(100% - 5px);
    }
  }
  </style>